<template>
  <footer class="pt-4 pb-2">
    <b-container>
      <b-row class="mb-4">
        <b-col cols="6"><img class="mw-100" src="@/assets/logo-footer.svg"/></b-col>
        <b-col cols="6" align="right"><img class="mw-100" src="@/assets/slogan-footer.svg"/></b-col>
      </b-row>
      <b-row class="mt-n1">
        <b-col lg="2" sm="3" cols="6">
          <b-nav class="mx-n2" vertical="vertical">
            <b-nav-text class="ml-2 navbar-title">Company</b-nav-text>
            <b-nav-item class="small" v-for="route in routes('company')" :key="route.path" :to="route.path" @click="$emit('routeClick', route)"><span v-html="$t('routes.' + route.name)"></span></b-nav-item>
          </b-nav>
        </b-col>
        <b-col lg="2" sm="3" cols="6">
          <b-nav class="mx-n2" vertical="vertical">
            <b-nav-text class="ml-2 navbar-title">Resources</b-nav-text>
            <b-nav-item class="small" v-for="route in routes('resources')" :key="route.path" :to="route.path" @click="$emit('routeClick', route)"><span v-html="$t('routes.' + route.name)"></span></b-nav-item>
          </b-nav>
        </b-col>
        <b-col lg="8" sm="6" cols="12" align-self="end">
          <b-nav class="justify-content-start justify-content-sm-end mx-n2 mb-2 mt-3 mt-sm-2">
            <b-nav-item href="https://www.instagram.com/hrdownloads"><img class="mx-n1" src="@/assets/instagram-icon.svg"/></b-nav-item>
            <b-nav-item href="https://www.linkedin.com/company/hrdownloads"><img class="mx-n1" src="@/assets/linkedin-icon.svg"/></b-nav-item>
            <b-nav-item href="https://twitter.com/HRdownloadsinc"><img class="mx-n1" src="@/assets/twitter-icon.svg"/></b-nav-item>
            <b-nav-item href="https://www.facebook.com/HRdownloads"><img class="mx-n1" src="@/assets/facebook-icon.svg"/></b-nav-item>
          </b-nav>
          <b-nav class="align-items-start align-items-sm-end mx-n2 text-center text-sm-right" vertical="vertical">
            <b-nav-item href="tel:18774389763" target="_blank">1.877.438.9763</b-nav-item>
            <b-nav-item class="address-link" href="https://goo.gl/maps/2qAP43a3uMZRsgyF6" target="_blank">727 Exeter Rd, London, ON N6E 1L3</b-nav-item>
          </b-nav>
        </b-col>
      </b-row>
      <background-wrapper class="mb-2 mt-4" color="white" contentPadding="1px 0 0 0"></background-wrapper>
      <b-row class="justify-content-lg-center">
        <b-col class="justify-content-lg-center" lg="5" order-lg="0" order="1">
          <b-nav class="mx-n2 small justify-content-lg-start justify-content-sm-start" align="center">
            <b-nav-item-dropdown class="mr-2" :text="$t('locales.' + i18n.locale)" left="left">
              <b-dropdown-item v-for="lang in i18n.availableLocales" :key="lang" @click="$emit('change-locales', lang)" href="#"><span v-html="$t('locales.' + lang)"></span></b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-text>&copy; {{year}} HRdownloads, all rights reserved</b-nav-text>
          </b-nav>
        </b-col>
        <b-col lg="7">
          <b-nav class="mx-n2 small justify-content-lg-end justify-content-sm-start" align="center">
            <b-nav-item v-for="route in routes('footerNav')" :key="route.path" :to="route.path" @click="$emit('routeClick', route)"><span v-html="$t('routes.' + route.name)"></span></b-nav-item>
          </b-nav>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: ['i18n'],
  data () {
    return {
      year: new Date().getFullYear(),
      routes: function (groupName) { return this.$router.options.routes.filter(route => route.groups && route.groups[groupName]).sort((a, b) => a.groups[groupName] - b.groups[groupName]) }
    }
  }
}
</script>

<style lang="sass" scoped>
footer
  background-color: $indigo
  color: $white
  overflow-x: hidden

hr
  background-color: #666B75

.navbar-title
  font-size: 12px
  letter-spacing: .2px
  text-transform: uppercase
  color: #CDBCF6

.nav .nav-link
  font-size: 14px
  letter-spacing: .2px
  color: $white
  &:hover
    color: $white
    text-decoration: underline

.address-link
  a
    +media-breakpoint-only(sm)
      padding-left: 0
      margin-left: -10px
</style>

<style lang="sass">
footer .dropdown-toggle
  color: $white
  &:hover
    color: $white
    text-decoration: underline
</style>



// WEBPACK FOOTER //
// src/components/ui/Footer.vue